import { axiosService } from '@services'

import { API } from '../endPoints'

export default async function getSummaryDashboards() {
  return axiosService({ method: 'GET', apiPath: API.ADMIN_DASHBOARD })
}
